import { Box, Typography } from '@material-ui/core'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { EmptyState } from '@/components/empty-state'
import { DiagnosisDTO } from '@/hooks/queries/use-get-physiological-diagnoses'

import { Row } from './row'
import { useStyles } from './styles'

interface DiagnosesTableProps {
  diagnoses: DiagnosisDTO[]
}

export const DiagnosesTable = ({ diagnoses }: DiagnosesTableProps) => {
  const classes = useStyles()
  const navigate = useNavigate()
  const location = useLocation()

  const initialOpenRowId = location.state?.openRowId || null
  const [openRowId, setOpenRowId] = useState<string | null>(initialOpenRowId)

  const handleRowClick = (row: DiagnosisDTO) => {
    if (row.status.status_key !== 'completed') return
    const newOpenRowId = openRowId === row.id ? null : row.id
    setOpenRowId(newOpenRowId)
    navigate(location, {
      state: { ...location.state, openRowId: newOpenRowId },
    })
  }

  return diagnoses.length ? (
    <Table padding='none' className={classes.table}>
      <TableHead>
        <TableRow>
          <TableCell>
            <Typography variant='subtitle2' color='textSecondary'>
              Data do voo
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant='subtitle2' color='textSecondary'>
              Projeto
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant='subtitle2' color='textSecondary'>
              Tags
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant='subtitle2' color='textSecondary'>
              Status
            </Typography>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {diagnoses.map((row) => (
          <Row
            key={row.id}
            row={row}
            isOpen={openRowId === row.id}
            onRowClick={() => handleRowClick(row)}
          />
        ))}
      </TableBody>
    </Table>
  ) : (
    <Box
      width='100%'
      height='100%'
      display='flex'
      alignItems='center'
      justifyContent='center'
    >
      <EmptyState
        description='Nenhum diagnóstico encontrado'
        srcImage='assets/img/envelope.svg'
      />
    </Box>
  )
}
